// no widget-scope dependencies, kept at module scope
function changeSponsorsStructure() {
  const $majorSponsorTitle = $('#scrollerSponsors #majorSponsorTitleContainer');
  const $majorSponsorContainer = $('#scrollerSponsors .majorSponsor');
  const majorSponsorsTitle = $('#majorSponsorTitleContainer .homepageh1').text();

  if ($majorSponsorContainer.length && $majorSponsorTitle.length) {
    $majorSponsorTitle.wrapAll('<div class="major-sponsor-wrapper" id="major-sponsor-wrapper">');
    $majorSponsorContainer.appendTo($('#major-sponsor-wrapper'));
    $('#major-sponsor-wrapper').prependTo($('#scrollerSponsors'));

    $('#majorSponsorTitleContainer .homepageh1').replaceWith(
      `<h2 class="major-sponsor-title">${majorSponsorsTitle}</h2>`,
    );
  }

  const sponsorsTitleContent = $('#sponsorsTitleContainer .homepageh1').text();
  $('#sponsorsTitleContainer .homepageh1').replaceWith(
    `<h2 class="main-sponsors-title">${sponsorsTitleContent}</h2>`,
  );

  $('#scrollerSponsors').append('<div class="scroller-container">');
  $('#scrollerSponsors .sponsorWidgetContainer ').appendTo('.scroller-container');
  $('#scrollerSponsors #sponsorArrowLeft').appendTo('.scroller-container');
  $('#scrollerSponsors #sponsorArrowRight').appendTo('.scroller-container');
}

export default function sponsors() {
  const widgetName = 'scrollerSponsors';
  const widgetOpts = scrollerSponsorsOpts;
  const $widget = $(`#${widgetName}`);

  if ($widget.length <= 1) {
    $widget.remove();
    return;
  }

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      // stop the interval if $widget.length is less than 1
      if ($widget.length <= 1) {
        clearInterval(interval);
        $widget.remove();
        return;
      }
      $widget.wrap('<div class="wrapper-sponsors">');
      setTimeout(() => {
        changeSponsorsStructure();
      }, 1000);
      clearInterval(interval);
    }
  }, 2000);

  return saffire.widgets.sponsors($($widget), {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: 6,
    bw: false,
    rotate: true,
  });
}
